import { createTheme } from '@mui/material/styles';
import { ThemeOptions } from '@mui/material/styles/createTheme';
import { commonThemeOptions } from './commonTheme';

const lightThemeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    background: {
      paper: '#ffffff',
      default: '#f4f4f4',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        elevation0: {
          backgroundColor: '#FCFBFC',
        },
        elevation1: {
          backgroundColor: '#F4F4F4',
          boxShadow: 'none',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#E0E0E0',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #697399',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #697399',
        },
      },
    },
  },
};

export const lightTheme = createTheme(lightThemeOptions, commonThemeOptions);
